import React from "react";
import { Figure } from "./Figure";
import { StrongLink } from "./StrongLink";
import styles from "./WizardHeader.module.css";

export type WizardHeaderProps = {
  title: string;
  intro: string;
  image?: URL;
  backlink?: boolean;
};

export const WizardHeader = ({
  title,
  intro,
  image,
  backlink = true,
}: WizardHeaderProps) => {
  return (
    <div className={styles.container}>
      {backlink && <StrongLink text="Terug naar de vragen" url="stappenplan" />}
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.intro}>{intro}</p>
      <Figure image={image} className={styles.image} />
    </div>
  );
};
